<template>
    <div>
        <ul>
            <li><a>Cash</a></li>
            <li><a>Status</a></li>
        </ul>
    </div>
</template>

<script>
    // import { mapActions } from 'vuex';

    export default {
        methods: {
            // ...mapActions([
            //     'logout'
            // ]),
        },
    }
</script>

<style lang="scss" scoped>


</style>